import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8h5sk43qpz: FaireBrandEntity = {
  token: "b_8h5sk43qpz",
  type: "brand",
  name: "Down To Earth",
  avatarUrl:
    "https://cdn.faire.com/fastly/d923c212a836a1a6d644b9cae9a888b354872bd50b00b4acb9e988c8f8d9f561.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e72af8772675a432a517249cbe79abe58b25819b4d80c2ca96a61029d081f308.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d923c212a836a1a6d644b9cae9a888b354872bd50b00b4acb9e988c8f8d9f561.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e72af8772675a432a517249cbe79abe58b25819b4d80c2ca96a61029d081f308.png",
  location: "Wichita, KS, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 81,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Down To Earth, where cosmic harmony meets ethically sourced treasures. As a mother-daughter team, we embark on a shared journey of enlightenment and well-being, curating products that resonate with the soul. Each item we offer is a testament to our passion for the metaphysical and our commitment to authenticity. Thank you for joining us on this cosmic exploration.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.225Z",
    importedBy: "entity-db-cli",
  },
};
